import { render, staticRenderFns } from "./HeatReport.vue?vue&type=template&id=2c7a7dfe&scoped=true&"
import script from "./HeatReport.vue?vue&type=script&lang=js&"
export * from "./HeatReport.vue?vue&type=script&lang=js&"
import style0 from "./HeatReport.vue?vue&type=style&index=0&id=2c7a7dfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a7dfe",
  null
  
)

export default component.exports